<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              관리자 인증 로그
            </div>
          </div>
          <hr>
          <!-- detail search start -->
          <b-card v-show="so.adv">
          <b-row>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="opt_date">시간</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-form-group>
                <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1일</b-button>
                <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1주</b-button>
                <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1달</b-button>
                <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1주</b-button>
                <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1달</b-button>
                <b-form inline class="mt-2">
                  <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
                  ~
                  <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
                </b-form>
              </b-form-group>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
              <label class="col-form-label" for="opt_group">결과</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-form-group>
                <select class="form-control" v-model="so.opt['is_valid']" @change="refresh">
                  <option disabled value="">성공인지 실패인지 선택하세요</option>
                  <option value="true">성공</option>
                  <option value="false">실패</option>
                </select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3" v-if="!user">
              <label class="col-form-label" for="opt_username_admin">사용자명</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 align-self-center">
              <b-form-group>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_username_admin" v-model="so.opt['username']"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
              <label class="col-form-label" for="opt_addr_admin">IP 주소</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 align-self-center">
              <b-form-group>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_addr_admin" v-model="so.opt['addr']"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
              <label class="col-form-label" for="opt_agent">에이전트</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 align-self-center">
              <b-form-group>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_agent" v-model="so.opt['agent']"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
              <label class="col-form-label" for="ph_search_opt_type">일치 유형</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-2">
              <b-form-group>
                <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                  <b-form-radio value="and">모두 일치</b-form-radio>
                  <b-form-radio value="or">최소 한개 이상 일치</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="float-right mt-3">
            <b-form-group>
              <b-button size="sm" variant="add" @click="refresh"> 찾기 </b-button>
              <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
              <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
            </b-form-group>
          </b-row>
        </b-card>
          <!-- detail search end -->
          <div class="d-flex flex-wrap align-items-center">
            <b-col sm="2">
              <span class="badge badge_border_primary mb-2">전체 : <span style="padding-left: 1rem">{{summaryData.total.toString().padStart(8, nbsp) | number}}</span></span>
              <br>
              <span class="badge badge_border_info mb-2">성공 : <span style="padding-left: 1rem">{{summaryData.good.toString().padStart(8, nbsp) | number}}</span></span>
              <br>
              <span class="badge badge_border_warning mb-2">실패 : <span style="padding-left: 1rem">{{summaryData.bad.toString().padStart(8, nbsp)| number}}</span></span>
            </b-col>
            
            <b-col class="md-10 d-flex flex-wrap align-items-center">
              <b-input-group size="sm">
                <div class="mr-auto mb7"></div>
                <div class="mr-2 mb7 mt-2">
                  <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="refresh()">
                    <i class="fas fa-sync-alt"></i>
                  </button>
                  <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="reset()">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
                <div class="mr-2 mb7">
                  <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || '찾기'" v-model="so.sk" @change="sv_reset">
                    <option disabled value="">검색</option>
                    <option v-if="!user" value="username">사용자명</option>
                    <option value="is_valid" >결과</option>
                    <option value="addr" >IP 주소</option>
                    <option value="Agent" >인증이 시도된 브라우저</option>
                  </select>
                </div>
                <div class="mr-2 mb7">
                  <select class="form-control col-xl-12" :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'is_valid'" @change="$refs._list.refresh()">
                    <option disabled value="">인증 성공인지 실패인지 선택하세요</option>
                    <option value="true">성공</option>
                    <option value="false">실패</option>
                  </select>
                </div>
                <div class="mr-2 mb7">
                  <b-form-input class="form-control col-xl-12" :disabled="so.adv" v-if="so.sk != 'is_valid'" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
                </div>
                <div class="mb7">
                  <button class="btn btn-icon1 mr-1" @click="refresh()">
                    <i class="fas fa-search"></i>
                  </button>
                  <!-- <button class="btn btn-icon2" @click="search_opt">
                    <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
                  </button> -->
                </div>
              </b-input-group>
              <br>
              <b-input-group size="sm">
                <div class="mr-auto mb7"></div>
                <div class="mb7">
                  <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh" style="margin-right:15px">
                    <option disabled value="15">표시되는 개수 : 기본 15개</option>
                    <option value=10>10</option>
                    <option value=50>50</option>
                    <option value=100>100</option>
                  </select>

                  <select class="form-control" name="sel2" id="sel2" v-if="sync.enable" v-model="sync.interval" @change="refresh" style="margin-right:15px">
                    <option disabled value="15">Please select interval : Default 15</option>
                    <option value=10>10</option>
                    <option value=30>30</option>
                    <option value=60>60</option>
                    <option value=300>300(5 min)</option>
                  </select>
                  <span v-if="sync.enable" class="float-right" style="margin-right:15px">
                    <i :class="`fa fa-refresh ${sync.th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
                    <b-btn @click="pause" size="sm" variant="warning">
                      {{!sync.stop ? "Auto refresh"  : "Pause"}}
                    </b-btn>
                  </span>
                </div>
              </b-input-group>
            </b-col>
          </div>
          <div class="reg_card">
            <div class="reg_card_body">
              <div class="table-responsive">
                <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요." :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
                  <template slot="created_at" slot-scope="row">{{ row.item.created_at | datetime }}</template>
                  <template slot="username" slot-scope="row">{{row.item.username}}</template>
                  <template slot="is_valid" slot-scope="row">
                    <b-badge v-if="row.item.is_valid" variant="success">
                      성공
                    </b-badge>
                    <b-badge v-else variant="danger">
                      실패
                    </b-badge>
                  </template>
                  <template slot="addr" slot-scope="row">{{row.item.addr}}</template>
                  <template slot="func" slot-scope="row">
                    <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">더보기</b-btn>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <b-row class="mt30">
            <b-col class="pagination justify-content-center">
              <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>